import { t } from "i18next";
import * as yup from "yup";

export const getNewPasswordSchema = () =>
  yup.object().shape({
    password: yup
      .string()
      .required(t("validation.required"))
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?"-:{}|<>]).{8,}$/,
        t("validation.passwordContain"),
      ),
    confirmPassword: yup
      .string()
      .required(t("validation.required"))
      .oneOf([yup.ref("password")], t("validation.passwordMustMatch")),
  });
